import {
  AuditOutlined,
  CheckSquareOutlined,
  DeleteOutlined,
  EditOutlined,
  FileProtectOutlined,
} from '@ant-design/icons';

export const consignOrderConst = {
  header: 'Orden de consigna',
  prefix: 'CN',
  duplicateAllotment: 'Ya hay un producto con este lote',
};

export const consignmentOrderTableOpt = () => {
  return [
    {
      label: 'Editar',
      key: 'edit',
      icon: <EditOutlined />,
      privilege: 'edit',
    },
    {
      label: 'Eliminar',
      key: 'delete',
      icon: <DeleteOutlined />,
      privilege: 'delete',
    },
    {
      label: 'Aprobar',
      key: 'approve',
      icon: <CheckSquareOutlined />,
      privilege: 'approve',
    },
    {
      label: 'Facturas',
      key: 'invoice',
      icon: <FileProtectOutlined />,
      privilege: 'reports',
    },
    {
      label: 'Devoluciones',
      key: 'refund',
      icon: <AuditOutlined />,
      privilege: 'reports',
    },
  ];
};

export const filters = {
  search: true,
  providers: true,
  dates: true,
  pendingStatus: true,
};

export const searchInputInitialValues = {
  search: { filter: 'order_number' },
};

export const searchFilters = [{ value: 'order_number', label: 'Número' }];

export const consignmentOrderMovimientTypes = {
  drop: 'drop',
  registration: 'registration',
};
